import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";

import {BarChart} from "d3plus-react";
import {removeDecimalsIfNotNeeded, cloneAndRenameObj, calculateDomain} from "../../../../../helpers/formatters";
import MiniLegend from "../../../../items/MiniLegend";
import Source from "../../../../items/Source";

class LaborMarketDevelopment extends Component {

  render() {
    const {clustersData, selectedRegion, nuts3Data, width} = this.props;

    if (!clustersData || !nuts3Data || !selectedRegion) {
      return '';
    }

    const selectedRegionID = selectedRegion.id;
    const nuts3Datum = nuts3Data.find(n3 => n3.nuts3_id === selectedRegionID);
    nuts3Datum.name = selectedRegion.name;

    const avgData = clustersData.find(cd => cd.cluster_id === nuts3Datum.cluster_id);

    avgData.color = "#cccccc";
    avgData.name = `${avgData.cluster_name} Cluster average`;

    //console.log(Object.keys(avgData));
    //console.log(Object.keys(nuts3Datum));

    const renameFields = {
      'nuts_3_region_net_job_growth_18_30_in_share': 'share_of_positive_job_growth_2018_30',
      'nuts_3_region_employment_rate_change_2018_30_in_p_p': 'employment_rate_change_2018_30_in_share',
      'nuts_3_region_working_age_population_change_2018_30_in_share': 'working_age_population_change_2018_30_in_thousands',
      'name': 'name'
    };

    const smallNuts3Data = cloneAndRenameObj(nuts3Datum, renameFields);
    smallNuts3Data.color = "#38bdf3";

    const filteredData = [
      avgData,
      smallNuts3Data
    ];

    console.log(filteredData);

    const colors = filteredData.map(d => ({color: d.color, label: d.name}));

    const fields = {
      'share_of_positive_job_growth_2018_30': 'Net job growth, %',
      'employment_rate_change_2018_30_in_share': 'Employment rate change, p.p.',
      'working_age_population_change_2018_30_in_thousands': 'Working-age population change, 2018-30, %',
    };

    let barW = width < 1000 ? 30 : 50;
    barW = width < 768 ? 20 : 50;

    const finalData = [];
    let xMax = 0;
    let xMin = 0;
    let value;
    Object.keys(fields).forEach(f => {
      filteredData.forEach(fd => {
        value = fd[f]*100;
        finalData.push({cluster_id: fd.cluster_id, name: fd.name, cluster_name: fd.cluster_name, property: fields[f], value: value, color: fd.color});
        xMax = xMax < value ? value : xMax;
        xMin = xMin > value ? value : xMin;
      });
    });

    const chartConfig = {
      data: finalData,
      groupBy: ["name"],
      legend: false,
      height: 400,
      discrete: "x",
      duration: 0,
      x: "property",
      y: "value",
      tooltipConfig: {
        body: d => `<div>${d.property}: ${removeDecimalsIfNotNeeded(d.value)}%</div>`
      },
      xConfig: {
        title: false,
        tickSize: 0,
        barConfig: {
          stroke: "#666",
          strokeWidth: 1
        }
      },
      yConfig: {
        title: false,
        tickSize: 0,
        tickFormat: x => `${Math.round(x)}%`,
        domain: calculateDomain(xMin, xMax, true),
        gridConfig: {
          stroke: d => Math.abs(d.id) === 0 ? "#666" : "#fff",
          strokeWidth: 1
        },
        barConfig: {
          stroke: "#666",
          strokeWidth: 1
        },
        shapeConfig: {
          stroke: "#efefef",
          strokeWidth: 1
        }
      },
      shapeConfig: {
        fill: d => d.color,
        Bar: {
          width: barW,
          label: d => {
            const sign = (d.property === "Employment rate change, p.p.") ? 'p.p.' : '%';
            return `${removeDecimalsIfNotNeeded(d.value)}${sign}`;
          },
          labelBounds: (d, ix, s) => {
            const w = 100;
            const h = !s.height ? 50 : s.height;
            let y = d.value < 0 ? h : -h - 25;
            return {
              width: w,
              height: 50,
              x: -w / 2,
              y: y,
              value: d.value
            };
          },
          labelConfig: {
            textAnchor: (d) => "middle",
            fontColor: () => "#000",
            fontFamily: () => "'FOW Theinhardt', sans-serif",
            fontSize: () => 12,
            fontWeight: () => 400
          }
        }
      },
      legendTooltip: {
        body: "",
        footer: "",
      },
      groupPadding: 5,
      barPadding: 2,
      on: {"click.legend": () => {}}
    };
    return (
      <CarouselItem title="Potential labor demand changes 2018-2030">
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <div className="fow-col-1-2-center-chart">
            <BarChart config={chartConfig} />
          </div>
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    nuts3Data: state.db.data.facts.nuts3_future ? state.db.data.facts.nuts3_future : false,
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : false,
    //clustersData: state.db.data.facts.clusters_avg ? state.db.data.facts.clusters_avg : false,
    selectedRegion: state.settings.map["Regions"],
    width: state.settings.window.width
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborMarketDevelopment);
